/* eslint-disable */
import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { memo, useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { CheckSquareOutlined, InboxOutlined } from '@ant-design/icons';
import excel from 'assets/images/icons/excel.svg';
import ErrorModal from 'pages/comptroller/ErrorModal';

import { Button, Col, Flex, Form, Popover, Row, Upload } from 'antd';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { useGetAllIdentityCaseMutation } from 'store/features/process/processApi';
import { exportExcelFile, handleFileUpload } from 'pages/globals/FileUploadExcel';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import dayjs from 'dayjs';
import { formatNumber } from '../leaseRecodTable';

const { Dragger } = Upload;
const INITIAL_EXPORT_DATA = [
	{
		'Reference Id': '',
		'Lease Title': '',
		'Lease Type': '',
		'Lessor Name': '',
		'Payment Frequency': '',
		'Lease Start Date (YYYY-MM-DD)': '',
		'Lease Effective Date (YYYY-MM-DD)': '',
		'Rent (From Month)': '',
		'Rent (To Month)': '',
		'Rent Amount': '',
		'Advance (From Month)': '',
		'Advance (To Month)': '',
		'Advance Adjustment Amount': '',
		'Incremental Borrowing Rate': '',
		'Escalation (%)': '',
		'Payment Modality': '',
	},
];
const TABLE_COLUMNS = [
	{ id: 'referenceId', align: 'center', disablePadding: true, label: 'Reference Id', key: 'Reference Id' },
	{ id: 'leaseTitle', align: 'center', disablePadding: true, label: 'Lease Title', key: 'Lease Title' },
	{ id: 'leaseType', align: 'center', disablePadding: true, label: 'Lease Type', key: 'Lease Type' },
	{ id: 'lessorName', align: 'center', disablePadding: true, label: 'Lessor Name', key: 'Lessor Name' },
	{ id: 'paymentFrequency', align: 'center', disablePadding: true, label: 'Payment Frequency', key: 'Payment Frequency' },
	{ id: 'leaseStartDate', align: 'center', disablePadding: true, label: 'Lease Start Date (YYYY-MM-DD)', key: 'Lease Start Date (YYYY-MM-DD)' },
	{
		id: 'leaseEffectiveDate',
		align: 'center',
		disablePadding: true,
		label: 'Lease Effective Date (YYYY-MM-DD)',
		key: 'Lease Effective Date (YYYY-MM-DD)',
	},
	{ id: 'rentFromMonth', align: 'center', disablePadding: true, label: 'Rent (From Month)', key: 'Rent (From Month)' },
	{ id: 'rentToMonth', align: 'center', disablePadding: true, label: 'Rent (To Month)', key: 'Rent (To Month)' },
	{ id: 'rentAmount', align: 'center', disablePadding: true, label: 'Rent Amount', key: 'Rent Amount' },
	{ id: 'advanceFromMonth', align: 'center', disablePadding: true, label: 'Advance (From Month)', key: 'Advance (From Month)' },
	{ id: 'AdvanceToMonth', align: 'center', disablePadding: true, label: 'Advance (To Month)', key: 'Advance (To Month)' },
	{ id: 'advanceAdjustmentAmount', align: 'center', disablePadding: true, label: 'Advance Adjustment Amount', key: 'Advance Adjustment Amount' },
	{ id: 'internalBorrowingRate', align: 'center', disablePadding: true, label: 'Incremental Borrowing Rate', key: 'Incremental Borrowing Rate' },
	{ id: 'escalation', align: 'center', disablePadding: true, label: 'Escalation (%)', key: 'Escalation (%)' },
	{ id: 'paymentModality', align: 'center', disablePadding: true, label: 'Payment Modality', key: 'Payment Modality' },
	{ id: 'lrmAction', align: 'center', disablePadding: true, label: 'Action', key: 'Action' },
];
const transformErrors = (errorObj, index) => {
	return Object.entries(errorObj).map(([field, message]) => ({ DataIndex: index, field, message }));
};
const formatDecimal = (number) => {
	return Number(number).toFixed(2);
};
const formatDate = (dateStr) => {
	if (typeof dateStr !== 'string') return '';
	let [year, month, day] = dateStr.split('-').map((num) => num.padStart(2, '0'));
	// if (+day < 10 || !day.includes('0')) day = '0' + day;
	return `${year}-${month}-${day}`;
};
const formatEffectiveDate = (dateStr) => {
	if (typeof dateStr !== 'string') return '';
	let [year, month, day] = dateStr.split('-').map((num) => num.padStart(2, '0'));
	if (+day < 10 && !day.includes('0')) day = '0' + day;
	return `${year}-${month}-${day}`;
};
const calculateMonthDifference = (effectiveDateInput, startDateInput) => {
	const effectiveDate = dayjs(effectiveDateInput);

	const startDate = dayjs(startDateInput);

	let monthDifference = (effectiveDate.year() - startDate.year()) * 12 + (effectiveDate.month() - startDate.month());
	monthDifference += 1;

	// Ensure non-negative
	if (monthDifference < 0) {
		monthDifference = 0;
	}

	return monthDifference;
};
const parseAndFormatExcelDate = (excelDate) => {
	const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;
	const EXCEL_START_DATE = new Date(1900, 0, 1);

	// Adjust for Excel's leap year bug
	const daysToAdd = excelDate > 59 ? excelDate - 1 : excelDate;

	// Convert to JavaScript Date
	const date = new Date(EXCEL_START_DATE.getTime() + daysToAdd * MILLISECONDS_PER_DAY);

	// Format the date
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	let day = String(date.getDate()).padStart(2, '0');
	day = String(+day - 1);

	return `${year}-${month}-${day}`;
};
const getDateParts = (date) => {
	// if (!(date instanceof Date)) {
	// 	return;
	// }
	const [year, month, day] = date.split('-').map((num) => num.padStart(2, '0'));
	return {
		day,
		month,
		year,
	};
};
const OptimizedTableCell = memo(({ column, lrm, getCellStyle, getCellContent }) => {
	const align = column.key === 'Lease Title' || column.key === 'Lessor Name' ? 'left' : 'center';

	if (column.key === 'Action') {
		return <TableCell align={align}>{getCellContent(column.key, null, lrm)}</TableCell>;
	}

	return (
		<TableCell align={align}>
			<div style={getCellStyle(column.key, lrm[column.key], lrm)}>{getCellContent(column.key, lrm[column.key], lrm)}</div>
		</TableCell>
	);
});
const OptimizedTableRow = memo(({ lrm, index, columns, getCellStyle, getCellContent }) => {
	return (
		<TableRow hover role="checkbox" sx={{ '&:last-child td, &:last-child th': { border: 0 } }} tabIndex={-1}>
			{columns.map((column, colIndex) => (
				<OptimizedTableCell
					key={`${index}-${colIndex}`}
					column={column}
					lrm={lrm}
					getCellStyle={getCellStyle}
					getCellContent={getCellContent}
				/>
			))}
		</TableRow>
	);
});
const findMaxLeaseTerm = (data) => {
	return data.reduce((max, item) => {
		// Convert values to numbers, treating "-" as 0
		const rentToMonth = item['Rent (To Month)'] === '-' ? 0 : Number(item['Rent (To Month)']);
		const advanceToMonth = item['Advance (To Month)'] === '-' ? 0 : Number(item['Advance (To Month)']);

		// Find the maximum between current max, rentToMonth, and advanceToMonth
		return Math.max(max, rentToMonth, advanceToMonth);
	}, 0);
};
const sumOfRentAmounts = (data) => {
	return data.reduce((sum, item) => {
		// Check if Rent Amount is not "-"
		if (item['Rent Amount'] !== '-') {
			// Add the numeric value to the sum
			sum += Number(item['Rent Amount']);
		}
		return sum;
	}, 0);
};
// const sumOfAdvanceAdjustmentAmounts = (data) => {
// 	return data.reduce((sum, item) => {
// 		// Check if Rent Amount is not "-"
// 		if (item['Advance Adjustment Amount'] !== '-') {
// 			// Add the numeric value to the sum
// 			sum += Number(item['Advance Adjustment Amount']);
// 		}
// 		return sum;
// 	}, 0);
// };
// const formatAmount = (amount) => {
// 	return amount.toLocaleString('en-US', {
// 		minimumFractionDigits: 2,
// 		maximumFractionDigits: 2,
// 	});
// };
// const createAdvanceArrays = (data, leaseTerm = 48) => {
// 	const inputChangeAdvanceAmounts = new Array(leaseTerm).fill(0);
// 	const advanceAmountList = [];

// 	// Extract advance payments
// 	data.forEach((item) => {
// 		if (item['Advance (From Month)'] !== '-' && item['Advance (To Month)'] !== '-' && item['Advance Adjustment Amount'] !== '-') {
// 			const from = Number(item['Advance (From Month)']);
// 			const to = Number(item['Advance (To Month)']);
// 			const amount = Number(item['Advance Adjustment Amount']);

// 			// Fill inputChangeAdvanceAmounts
// 			for (let month = from; month <= to; month++) {
// 				if (month - 1 < leaseTerm) {
// 					inputChangeAdvanceAmounts[month - 1] = amount;
// 				}
// 			}

// 			// Add to structured array
// 			advanceAmountList.push({
// 				from: from,
// 				to: to.toString(),
// 				amount: formatAmount(amount),
// 			});
// 		}
// 	});

// 	// Sort structured array by 'from' value
// 	advanceAmountList.sort((a, b) => a.from - b.from);

// 	// Remove duplicates based on 'from' value if needed
// 	const uniqueStructuredArray = advanceAmountList.filter((item, index, self) => index === self.findIndex((t) => t.from === item.from));

// 	return {
// 		inputChangeAdvanceAmounts,
// 		advanceAmountList: uniqueStructuredArray,
// 	};
// };
// const createRentArrays = (data, leaseTerm = 48) => {
// 	// Initialize the value array with zeros
// 	const inputChangeGrossRents = new Array(leaseTerm).fill(0);

// 	// Array to hold structured rent information
// 	const grossRentList = [];

// 	// Process each item in the data
// 	data.forEach((item) => {
// 		// Skip if rent values are "-"
// 		if (item['Rent (From Month)'] !== '-' && item['Rent (To Month)'] !== '-' && item['Rent Amount'] !== '-') {
// 			const from = Number(item['Rent (From Month)']);
// 			const to = Number(item['Rent (To Month)']);
// 			const amount = Number(item['Rent Amount']);

// 			// Fill the inputChangeGrossRents for the specified range
// 			for (let month = from; month <= to; month++) {
// 				if (month - 1 < leaseTerm) {
// 					inputChangeGrossRents[month - 1] = amount;
// 				}
// 			}

// 			// Create structured object with formatted amount
// 			grossRentList.push({
// 				from: from,
// 				to: to.toString(),
// 				amount: formatAmount(amount),
// 				remarks: item['Remarks'] || '', // If you have a remarks field in your data
// 				// Or you can set static remarks based on some logic:
// 				// remarks: from === 1 ? "abc" : from === 13 ? "xyz" : from === 25 ? "abc" : "max"
// 			});
// 		}
// 	});

// 	// Sort structured array by 'from' value
// 	grossRentList.sort((a, b) => a.from - b.from);

// 	// Remove duplicates based on 'from' value
// 	const uniqueStructuredArray = grossRentList.filter((item, index, self) => index === self.findIndex((t) => t.from === item.from));

// 	return {
// 		inputChangeGrossRents,
// 		grossRentList: uniqueStructuredArray,
// 	};
// };
// const findMaxAdvanceToMonth = (data) => {
// 	return data.reduce((max, item) => {
// 		// Check if Advance (To Month) is not "-"
// 		if (item['Advance (To Month)'] !== '-') {
// 			const advanceToMonth = Number(item['Advance (To Month)']);
// 			return Math.max(max, advanceToMonth);
// 		}
// 		return max;
// 	}, 0);
// };
const processLeaseData = (data) => {
	// Helper function to format amounts
	const formatAmount = (amount) => {
		return amount.toLocaleString('en-US', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
	};

	// Find max lease term from the data
	const maxLeaseTerm = data.reduce((max, item) => {
		const rentToMonth = item['Rent (To Month)'] === '-' ? 0 : Number(item['Rent (To Month)']);
		const advanceToMonth = item['Advance (To Month)'] === '-' ? 0 : Number(item['Advance (To Month)']);
		return Math.max(max, rentToMonth, advanceToMonth);
	}, 0);

	// Use the calculated maxLeaseTerm
	const leaseTerm = maxLeaseTerm || 48; // fallback to 48 if no data

	// Process advance data
	const inputChangeAdvanceAmounts = new Array(leaseTerm).fill(0);
	const advanceAmountList = [];
	let totalAdvanceAmount = 0;
	let maxAdvanceToMonth = 0;

	data.forEach((item) => {
		if (item['Advance (From Month)'] !== '-' && item['Advance (To Month)'] !== '-' && item['Advance Adjustment Amount'] !== '-') {
			const from = Number(item['Advance (From Month)']);
			const to = Number(item['Advance (To Month)']);
			const amount = Number(item['Advance Adjustment Amount']);

			// Update max advance month
			maxAdvanceToMonth = Math.max(maxAdvanceToMonth, to);

			// Add to total
			totalAdvanceAmount += amount;

			// Fill value array
			for (let month = from; month <= to; month++) {
				if (month - 1 < leaseTerm) {
					inputChangeAdvanceAmounts[month - 1] = amount;
				}
			}

			// Add to structured array
			advanceAmountList.push({
				from: from,
				to: to.toString(),
				amount: formatAmount(amount),
			});
		}
	});

	// Process rent data
	const inputChangeGrossRents = new Array(leaseTerm).fill(0);
	const grossRentList = [];
	let totalRentAmount = 0;

	data.forEach((item) => {
		if (item['Rent (From Month)'] !== '-' && item['Rent (To Month)'] !== '-' && item['Rent Amount'] !== '-') {
			const from = Number(item['Rent (From Month)']);
			const to = Number(item['Rent (To Month)']);
			const amount = Number(item['Rent Amount']);

			// Add to total
			totalRentAmount += amount;

			// Fill value array
			for (let month = from; month <= to; month++) {
				if (month - 1 < leaseTerm) {
					inputChangeGrossRents[month - 1] = amount;
				}
			}

			// Add to structured array
			grossRentList.push({
				from: from,
				to: to.toString(),
				amount: formatAmount(amount),
				remarks: '',
			});
		}
	});

	// Sort and remove duplicates
	advanceAmountList.sort((a, b) => a.from - b.from);
	grossRentList.sort((a, b) => a.from - b.from);

	const uniqueAdvanceList = advanceAmountList.filter((item, index, self) => index === self.findIndex((t) => t.from === item.from));

	const uniqueRentList = grossRentList.filter((item, index, self) => index === self.findIndex((t) => t.from === item.from));

	return {
		// Advance related outputs
		inputChangeAdvanceAmounts,
		advanceAmountList: uniqueAdvanceList,
		totalAdvanceAmount,
		maxAdvanceToMonth,

		// Rent related outputs
		inputChangeGrossRents,
		grossRentList: uniqueRentList,
		totalRentAmount,

		// Lease term
		maxLeaseTerm,
		leaseTerm, // This is the same as maxLeaseTerm (or 48 if no data)
	};
};
const LeaseBulkUpload = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const { state } = useLocation();
	// const [show, setShow] = useState(false);
	// const [excelData, setExcelData] = useState([]);
	// const [modalInfo, setModalInfo] = useState(null);
	// const [excelTable, setExcelTable] = useState([]);
	// const [showModal, setShowModal] = useState(false);
	// const [filesubmitButton, setFileSubmitButton] = useState(false);
	const [uiState, setUiState] = useState({
		show: false,
		showModal: false,
		fileSubmitButton: false,
	});
	const setShowModal = useCallback((value) => {
		setUiState((prev) => ({ ...prev, showModal: value }));
	}, []);
	const setShow = useCallback((value) => {
		setUiState((prev) => ({ ...prev, show: value }));
	}, []);
	const setFileSubmitButton = useCallback((value) => {
		setUiState((prev) => ({ ...prev, fileSubmitButton: value }));
	}, []);
	const [data, setData] = useState({
		excelData: [],
		excelTable: [],
		modalInfo: null,
	});
	const setExcelTable = useCallback((value) => {
		setData((prev) => ({ ...prev, excelTable: value }));
	}, []);

	const [UploadBulkIdentityCase, { error: errorData, isSuccess: isBulkCaseSuccess, isError: isBulkCaseError }] = useGetAllIdentityCaseMutation();

	const onFinish = (values) => {};

	useEffect(() => {
		// Check if every item's remark is valid.
		const allValid = data.excelTable.every((item) => {
			return item['Remarks'].valid;
		});

		// Set the submit button state based on that check.
		setFileSubmitButton(!allValid);
	}, [data.excelTable]);

	const getModifiedData = useCallback((data) => {
		// Create a mapping from Lease Id to a sequential Data No.
		const leaseIdToDataNo = {};
		let dataNoCounter = 1;

		return data.map((item) => {
			const leaseId = item?.['Lease Id'];

			// Assign a new Data No. if this Lease Id is encountered for the first time.
			if (!leaseIdToDataNo.hasOwnProperty(leaseId)) {
				leaseIdToDataNo[leaseId] = dataNoCounter;
				dataNoCounter++;
			}

			// Build the remarks object with keys for each error field.
			let remarks = {};

			// Required fields that must be non-empty for every row:
			if (item?.['Payment Frequency'] === '' || item?.['Payment Frequency'] === undefined) {
				remarks['Payment Frequency'] = 'Payment Frequency is required';
			} else if (item?.['Payment Frequency'] !== 'Monthly' && item?.['Payment Frequency'] !== 'Quarterly') {
				remarks['Payment Frequency'] = 'Payment Frequency must be either Monthly or Quarterly';
			}
			if (!item?.['Lease Start Date (YYYY-MM-DD)']) {
				remarks['Lease Start Date (YYYY-MM-DD)'] = 'Lease Start Date (YYYY-MM-DD) is required';
			}
			if (!item?.['Lease Effective Date (YYYY-MM-DD)']) {
				remarks['Lease Effective Date (YYYY-MM-DD)'] = 'Lease Effective Date (YYYY-MM-DD) is required';
			}
			// if (item?.['Lease Term'] === '' || item?.['Lease Term'] === undefined) {
			// 	remarks['Lease Term'] = 'Lease Term is required';
			// }
			//  else if (isNaN(Number(item?.['Lease Term']))) {
			// 	remarks['Lease Term'] = 'Lease Term must be a number';
			// }

			if (item?.['Rent Amount'] === '' || item?.['Rent Amount'] === undefined) {
				remarks['Rent Amount'] = 'Rent Amount is required. If not applicable, please enter -';
			} else if (isNaN(Number(item?.['Rent Amount'])) && item?.['Rent Amount'] !== '-') {
				remarks['Rent Amount'] = 'Rent Amount must be a number';
			}
			if (item?.['Rent (From Month)'] === '' || item?.['Rent (From Month)'] === undefined) {
				remarks['Rent (From Month)'] = 'Rent (From Month) is required. If not applicable, please enter -';
			} else if (isNaN(Number(item?.['Rent (From Month)'])) && item?.['Rent (From Month)'] !== '-') {
				remarks['Rent (From Month)'] = 'Rent (From Month) must be a number';
			}
			if (item?.['Rent (To Month)'] === '' || item?.['Rent (To Month)'] === undefined) {
				remarks['Rent (To Month)'] = 'Rent (To Month) is required. If not applicable, please enter -';
			} else if (isNaN(Number(item?.['Rent (To Month)'])) && item?.['Rent (To Month)'] !== '-') {
				remarks['Rent (To Month)'] = 'Rent (To Month) must be a number';
			}
			if (item?.['Advance (From Month)'] === '' || item?.['Advance (From Month)'] === undefined) {
				remarks['Advance (From Month)'] = 'Advance (From Month) is required. If not applicable, please enter -';
			} else if (isNaN(Number(item?.['Advance (From Month)'])) && item?.['Advance (From Month)'] !== '-') {
				remarks['Advance (From Month)'] = 'Advance (From Month) must be a number';
			}
			if (item?.['Advance (To Month)'] === '' || item?.['Advance (To Month)'] === undefined) {
				remarks['Advance (To Month)'] = 'Advance (To Month) is required. If not applicable, please enter -';
			} else if (isNaN(Number(item?.['Advance (To Month)'])) && item?.['Advance (To Month)'] !== '-') {
				remarks['Advance (To Month)'] = 'Advance (To Month) must be a number';
			}
			if (item?.['Advance Adjustment Amount'] === '' || item?.['Advance Adjustment Amount'] === undefined) {
				remarks['Advance Adjustment Amount'] = 'Advance Adjustment Amount is required. If not applicable, please enter -';
			} else if (isNaN(Number(item?.['Advance Adjustment Amount'])) && item?.['Advance Adjustment Amount'] !== '-') {
				remarks['Advance Adjustment Amount'] = 'Advance Adjustment Amount must be a number';
			}
			// if (item?.['Security Deposit'] === '' || item?.['Security Deposit'] === undefined) {
			// 	remarks['Security Deposit'] = 'Security Deposit is required';
			// }
			if (item?.['Incremental Borrowing Rate'] === '' || item?.['Incremental Borrowing Rate'] === undefined) {
				remarks['Incremental Borrowing Rate'] = 'Incremental Borrowing Rate is required';
			} else if (isNaN(Number(item?.['Incremental Borrowing Rate']))) {
				remarks['Incremental Borrowing Rate'] = 'Incremental Borrowing Rate must be a number';
			}
			if (item?.['Escalation (%)'] === '' || item?.['Escalation (%)'] === undefined) {
				remarks['Escalation (%)'] = 'Escalation (%) is required';
			} else if (isNaN(Number(item?.['Escalation (%)']))) {
				remarks['Escalation (%)'] = 'Escalation (%) must be a number';
			}
			// if (item?.['Advance Duration'] === '' || item?.['Advance Duration'] === undefined) {
			// 	remarks['Advance Duration'] = 'Advance Duration is required';
			// } else if (isNaN(Number(item?.['Advance Duration']))) {
			// 	remarks['Advance Duration'] = 'Advance Duration must be a number';
			// }
			// if (item?.['Advance Amount'] === '' || item?.['Advance Amount'] === undefined) {
			// 	remarks['Advance Amount'] = 'Advance Amount is required';
			// } else if (isNaN(Number(item?.['Advance Amount']))) {
			// 	remarks['Advance Amount'] = 'Advance Amount must be a number';
			// }
			if (item?.['Payment Modality'] === '' || item?.['Payment Modality'] === undefined) {
				remarks['Payment Modality'] = 'Payment Modality is required';
			} else if (
				item?.['Payment Modality']?.toLowerCase() !== 'advance basis' &&
				item?.['Payment Modality']?.toLowerCase() !== 'accrual basis'
			) {
				remarks['Payment Modality'] = 'Payment Modality must be either Advance Basis or Accrual Basis';
			}

			if (Object.keys(remarks).length === 0) {
				remarks = { valid: true };
			}

			return {
				'Data No.': leaseIdToDataNo[leaseId],
				...item,
				Remarks: remarks,
			};
		});

		// return latestData;
	}, []);

	const validateData = useCallback(
		(data) => {
			const defaultKeys = Object.keys(INITIAL_EXPORT_DATA[0]);
			const normalizedData = data.map((obj) => {
				const newObj = { ...obj };
				defaultKeys.forEach((key) => {
					if (!newObj.hasOwnProperty(key)) {
						newObj[key] = '';
					}
				});
				return newObj;
			});

			setData((prev) => ({ ...prev, excelData: normalizedData }));
			const tableData = getModifiedData(normalizedData);
			tableData.sort((a, b) => a['Data No.'] - b['Data No.']);
			setData((prev) => ({ ...prev, excelTable: tableData }));
		},
		[getModifiedData]
	);

	const handleExcelSubmit = useCallback(() => {
		setData((prev) => ({
			...prev,
			modalInfo: {
				head: 'Lease Bulk Upload',
				action: 'submit',
				activationStatus: 'create new lease records',
			},
		}));
		setUiState((prev) => ({ ...prev, showModal: true, show: false }));
	}, []);

	const handleSubmitExcelData = useCallback(async () => {
		const payloadArray = [];
		const groupByTitle = _.groupBy(data.excelTable, 'Reference Id');
		// console.log('🚀 ~ handleSubmitExcelData ~ data.excelTable:', groupByTitle);

		for (let item in groupByTitle) {
			groupByTitle[item].sort((a, b) => dayjs(a['Reference Id']).diff(dayjs(b['Reference Id'])));
			// console.log('🚀 ~ handleSubmitExcelData ~ groupByTitle[item]:', groupByTitle[item]);

			const {
				// Advance related outputs
				inputChangeAdvanceAmounts,
				advanceAmountList,
				totalAdvanceAmount,
				maxAdvanceToMonth,

				// Rent related outputs
				inputChangeGrossRents,
				grossRentList,
				totalRentAmount,

				// Lease term
				maxLeaseTerm,
				leaseTerm,
				// This is the same as maxLeaseTerm (or 48 if no data)
			} = processLeaseData(groupByTitle[item]);
			const StartDate = parseAndFormatExcelDate(groupByTitle[item][0]['Lease Start Date (YYYY-MM-DD)']);
			const endDate = dayjs(parseAndFormatExcelDate(groupByTitle[item][0]['Lease Start Date (YYYY-MM-DD)']))
				.add(+maxLeaseTerm, 'month')
				.subtract(1, 'day')
				.format('YYYY-MM-DD');
			let advanceAmountListSetArray = [];
			let grossRentListSetArray = [];
			const formattedStartDate = formatDate(StartDate);
			const formattedEndDate = formatDate(endDate);
			const { day: startDay, month: startMonth, year: startYear } = getDateParts(dayjs(StartDate).format('YYYY-MM-DD'));
			// const dataLength = groupByTitle[item].length;

			const leaseChanges = [];
			// const { inputChangeAdvanceAmounts, advanceAmountList } = createAdvanceArrays(groupByTitle[item], findMaxLeaseTerm(groupByTitle[item]));
			// const { inputChangeGrossRents, grossRentList } = createRentArrays(groupByTitle[item], findMaxLeaseTerm(groupByTitle[item]));
			const leaseChangeObject = {
				inputChangeMonth: calculateMonthDifference(
					parseAndFormatExcelDate(groupByTitle[item][0]['Lease Effective Date (YYYY-MM-DD)']),
					parseAndFormatExcelDate(groupByTitle[item][0]['Lease Start Date (YYYY-MM-DD)'])
				),
				inputChangeLeaseTerm: maxLeaseTerm,
				inputChangeGrossAmount: totalRentAmount,
				inputChangeDiscountRate: String(groupByTitle[item][0]['Incremental Borrowing Rate']),
				inputChangeEscalation: String(groupByTitle[item][0]['Escalation (%)']),
				paymentFrequency:
					groupByTitle[item][0]['Payment Frequency']?.toLowerCase() === 'monthly'
						? 'Monthly'
						: groupByTitle[item][0]['Payment Frequency']?.toLowerCase() === 'quarterly'
							? 'Quarterly'
							: '',
				paymentTime:
					groupByTitle[item][0]['Payment Modality']?.toLowerCase() === 'advance basis'
						? 'Start'
						: groupByTitle[item][0]['Payment Modality']?.toLowerCase() === 'accrual basis'
							? 'End'
							: '',
				inputChangeAdvance: totalAdvanceAmount,
				inputChangeAmortizationPeriod: String(maxAdvanceToMonth),
				inputChangeEffectiveDate: formatEffectiveDate(parseAndFormatExcelDate(groupByTitle[item][0]['Lease Effective Date (YYYY-MM-DD)'])),
				inputChangeAdvanceAmounts: inputChangeAdvanceAmounts,
				inputChangeGrossRents: inputChangeGrossRents,
			};
			leaseChanges.push(leaseChangeObject);

			const obj = {
				leaseTitle: groupByTitle[item][0]['Lease Title'],
				leaseType: groupByTitle[item][0]['Lease Type'],
				lessorName: groupByTitle[item][0]['Lessor Name'],
				paymentFrequency: String(groupByTitle[item][0]['Payment Frequency']),
				leaseStartDate: `${formattedStartDate}T00:00:00.000Z`,
				leaseEndDate: formattedEndDate,
				leaseTerm: String(maxLeaseTerm),

				grossRent: 0,
				initialDiscountRate: String(groupByTitle[item][0]['Incremental Borrowing Rate']),
				escalationPercentage: String(groupByTitle[item][0]['Escalation (%)']),
				paymentModality: String(
					groupByTitle[item][0]['Payment Modality']?.toLowerCase() === 'advance basis'
						? 'Start'
						: groupByTitle[item][0]['Payment Modality']?.toLowerCase() === 'accrual basis'
							? 'End'
							: ''
				),
				advanceDuration: String(maxAdvanceToMonth),
				advanceAmount: String(totalAdvanceAmount),
				changes: leaseChanges,
				lastModifiedDate: dayjs(),
				endOfFinancialYear: dayjs().month(11).date(31),
				// deletionMarker: true,
				startDay,
				startMonth,
				startYear,
				advanceAmountList,
				grossRentList,
				advanceAmountListSet: [advanceAmountList],
				grossRentListSet: [grossRentList],
				grossRents: inputChangeGrossRents,
				advanceAmounts: inputChangeAdvanceAmounts,
				upfrontLeasePayment: 0,
				securityDeposit: 0,
				initialDirectCost: 0,
			};
			payloadArray.push(obj);
		}
		// console.log('🚀 ~ handleSubmitExcelData ~ payloadArray:', payloadArray);
		const payload = {
			operation: 'add-bulk',
			processCode: state?.processCode,
			suffixCode: '',
			data: payloadArray,
		};
		UploadBulkIdentityCase(payload);
	}, [data.excelTable, state?.processCode, UploadBulkIdentityCase]);

	useEffect(() => {
		if (data.excelTable.length > 0) {
			const allValid = data.excelTable.every((item) => item['Remarks'].valid);
			setUiState((prev) => ({ ...prev, fileSubmitButton: !allValid }));
		}
	}, [data.excelTable]);

	useEffect(() => {
		if (isBulkCaseSuccess) {
			navigate(-1);
		} else if (isBulkCaseError) {
			if (errorData?.data?.code === '501') {
				toast.error(errorData?.data?.message, toastConfig);
			} else {
				toast.error('Failed! Action not completed', toastConfig);
			}
		}
	}, [isBulkCaseSuccess]);

	// const columns = [
	// 	{
	// 		id: 'referenceId',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Reference Id',
	// 		key: 'Reference Id',
	// 	},

	// 	{
	// 		id: 'leaseTitle',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Lease Title',
	// 		key: 'Lease Title',
	// 	},

	// 	{
	// 		id: 'leaseType',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Lease Type',
	// 		key: 'Lease Type',
	// 	},
	// 	{
	// 		id: 'lessorName',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Lessor Name',
	// 		key: 'Lessor Name',
	// 	},
	// 	{
	// 		id: 'paymentFrequency',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Payment Frequency',
	// 		key: 'Payment Frequency',
	// 	},
	// 	{
	// 		id: 'leaseStartDate',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Lease Start Date (YYYY-MM-DD)',
	// 		key: 'Lease Start Date (YYYY-MM-DD)',
	// 	},
	// 	{
	// 		id: 'leaseEffectiveDate',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Lease Effective Date (YYYY-MM-DD)',
	// 		key: 'Lease Effective Date (YYYY-MM-DD)',
	// 	},
	// 	// {
	// 	// 	id: 'leaseTerm',
	// 	// 	align: 'center',
	// 	// 	disablePadding: true,
	// 	// 	label: 'Lease Term',
	// 	// },
	// 	{
	// 		id: 'rentFromMonth',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Rent (From Month)',
	// 		key: 'Rent (From Month)',
	// 	},
	// 	{
	// 		id: 'rentToMonth',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Rent (To Month)',
	// 		key: 'Rent (To Month)',
	// 	},
	// 	{
	// 		id: 'rentAmount',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Rent Amount',
	// 		key: 'Rent Amount',
	// 	},
	// 	{
	// 		id: 'advanceFromMonth',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Advance (From Month)',
	// 		key: 'Advance (From Month)',
	// 	},
	// 	{
	// 		id: 'AdvanceToMonth',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Advance (To Month)',
	// 		key: 'Advance (To Month)',
	// 	},
	// 	{
	// 		id: 'advanceAdjustmentAmount',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Advance Adjustment Amount',
	// 		key: 'Advance Adjustment Amount',
	// 	},
	// 	{
	// 		id: 'internalBorrowingRate',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Incremental Borrowing Rate',
	// 		key: 'Incremental Borrowing Rate',
	// 	},
	// 	{
	// 		id: 'escalation',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Escalation (%)',
	// 		key: 'Escalation (%)',
	// 	},
	// 	{
	// 		id: 'paymentModality',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Payment Modality',
	// 		key: 'Payment Modality',
	// 	},

	// 	{
	// 		id: 'lrmAction',
	// 		align: 'center',
	// 		disablePadding: true,
	// 		label: 'Action',
	// 		key: 'Action',
	// 	},
	// ];
	const getCellStyle = useCallback((columnKey, value, lrm) => {
		switch (columnKey) {
			case 'Payment Frequency':
				return {
					border: value === '' || !(value?.toLowerCase() === 'monthly' || value?.toLowerCase() === 'quarterly') ? '2px solid red' : '',
				};

			case 'Lease Start Date (YYYY-MM-DD)':
				return {
					border: value === '' ? '2px solid red' : '',
				};

			case 'Lease Effective Date (YYYY-MM-DD)':
				return {
					border: value === '' ? '2px solid red' : '',
				};

			case 'Rent (From Month)':
				return {
					border: value !== '-' && (value === '' || isNaN(Number(value))) ? '2px solid red' : '',
				};

			case 'Rent (To Month)':
				return {
					border: value !== '-' && (value === '' || isNaN(Number(value))) ? '2px solid red' : '',
				};

			case 'Rent Amount':
				return {
					border: value !== '-' && (value === '' || isNaN(Number(value))) ? '2px solid red' : '',
				};

			case 'Advance (From Month)':
				return {
					border: value !== '-' && (value === '' || isNaN(Number(value))) ? '2px solid red' : '',
				};

			case 'Advance (To Month)':
				// Special condition: check Advance (From Month) value
				return {
					border: lrm['Advance (From Month)'] !== '-' && (value === '' || isNaN(Number(value))) ? '2px solid red' : '',
				};

			case 'Advance Adjustment Amount':
				return {
					border: value !== '-' && (value === '' || isNaN(Number(value))) ? '2px solid red' : '',
				};

			case 'Incremental Borrowing Rate':
			case 'Escalation (%)':
				return {
					border: value === '' || isNaN(Number(value)) ? '2px solid red' : '',
				};

			case 'Payment Modality':
				return {
					border:
						value === '' || !(value?.toLowerCase() === 'advance basis' || value?.toLowerCase() === 'accrual basis')
							? '2px solid red'
							: '',
				};

			default:
				return {};
		}
	}, []);
	const getCellContent = useCallback((columnKey, value, lrm) => {
		switch (columnKey) {
			case 'Reference Id':
				return value;

			case 'Lease Title':
				return value;

			case 'Lease Type':
				return value;

			case 'Lessor Name':
				return value;

			case 'Payment Frequency':
				if (value === '') return ' Required ';
				if (value?.toLowerCase() === 'monthly' || value?.toLowerCase() === 'quarterly') {
					return value;
				}
				return ' Enter monthly or quarterly as value ';

			case 'Lease Start Date (YYYY-MM-DD)':
				return value === '' ? ' Required ' : formatDate(parseAndFormatExcelDate(value));

			case 'Lease Effective Date (YYYY-MM-DD)':
				return value === '' ? ' Required ' : formatDate(parseAndFormatExcelDate(value));

			case 'Rent (From Month)':
				if (value === '') return ' Required ';
				if (value === '-') return '-';
				if (isNaN(Number(value))) return ' Insert a Numeric Value ';
				return value;

			case 'Rent (To Month)':
				if (value === '') return ' Required ';
				if (lrm['Rent (From Month)'] === '-') return '-';
				if (isNaN(Number(value))) return ' Insert a Numeric Value ';
				return value;

			case 'Rent Amount':
				if (value === '') return ' Required ';
				if (value === '-') return '-';
				if (isNaN(Number(value))) return ' Insert a Numeric Value ';
				return formatNumber(value, 2);

			case 'Advance (From Month)':
				if (value === '') return ' Required ';
				if (value === '-') return '-';
				if (isNaN(Number(value))) return ' Insert a Numeric Value ';
				return value;

			case 'Advance (To Month)':
				if (value === '') return ' Required ';
				if (lrm['Advance (From Month)'] === '-') return '-';
				if (isNaN(Number(value))) return ' Insert a Numeric Value ';
				return value;

			case 'Advance Adjustment Amount':
				if (value === '') return ' Required ';
				if (value === '-') return '-';
				if (isNaN(Number(value))) return ' Insert a Numeric Value ';
				return formatNumber(value);

			case 'Incremental Borrowing Rate':
				if (value === '') return ' Required ';
				if (isNaN(Number(value))) return ' Insert a Numeric Value ';
				return value;

			case 'Escalation (%)':
				if (value === '') return ' Required ';
				if (isNaN(Number(value))) return ' Insert a Numeric Value ';
				return value;

			case 'Payment Modality':
				if (value === '') return ' Required ';
				if (value?.toLowerCase() === 'advance basis') return 'Advance Basis';
				if (value?.toLowerCase() === 'accrual basis') return 'Accrual Basis';
				return ' Enter Advance Basis or Accrual Basis as value ';

			case 'Action':
				// Special case for the action column
				return (
					<div>
						{lrm['Remarks'].valid ? (
							<CheckSquareOutlined
								size="large"
								style={{
									fontSize: '20px',
									color: theme.palette.lynTheme.success,
								}}
							/>
						) : (
							<Popover
								trigger="focus"
								placement="topLeft"
								content={<ErrorModal modalData={transformErrors(lrm['Remarks'], +lrm['Data No.'])} />}
							>
								<Button
									style={{
										backgroundColor: theme.palette.error?.main || 'red',
										marginRight: '10px',
									}}
									type="primary"
								>
									Show Errors
								</Button>
							</Popover>
						)}
					</div>
				);

			default:
				return value;
		}
	}, []);

	return (
		<div>
			<p style={{ paddingLeft: '20px' }}>
				To download a demo <img src={excel} alt="excel" width={22} style={{ margin: '0 5px' }} /> file{' '}
				<Button
					size="small"
					type="dashed"
					onClick={(e) => {
						e.stopPropagation();
						// exportExcelFile(exportData, exportDataTypes, 'LRM_BulkUpload.xlsx');
						exportExcelFile(INITIAL_EXPORT_DATA, 'LRM_BulkUpload.xlsx');
					}}
					style={{ color: '#1677ff', borderColor: '#1677ff' }}
				>
					Click Here
				</Button>
			</p>

			<Form
				name="basic"
				layout="vertical"
				labelCol={{
					span: 12,
				}}
				wrapperCol={{
					span: 24,
				}}
				onFinish={onFinish}
				// onFinishFailed={onFinishFailed}
			>
				<Row gutter={[24, 24]}>
					<Col xs={24} sm={24} md={24} xl={24}>
						<Form.Item
							rules={[
								{
									required: true,
								},
							]}
						>
							{!uiState?.show && (
								<Dragger
									name="file"
									// action="/your-upload-endpoint" // Replace with your actual upload endpoint
									customRequest={({ file }) => {
										handleFileUpload(file, validateData, setShow);
									}}
									showUploadList={false}
									accept=".xlsx, .xls" // Specify the accepted file types (Excel files)
								>
									<p className="ant-upload-drag-icon">
										<InboxOutlined />
									</p>
									<p className="ant-upload-text">Click or drag Excel file to this area to upload</p>
									<p className="ant-upload-hint">Support for .xlsx and .xls files.</p>
								</Dragger>
							)}

							<br></br>

							{uiState.show && data.excelData && (
								<Box>
									<TableContainer
										sx={{
											width: '100%',
											overflowX: 'auto',
											position: 'relative',
											display: 'block',
											maxWidth: '100%',
											'& td, & th': { whiteSpace: 'nowrap' },
										}}
									>
										<Table
											aria-labelledby="tableTitle"
											sx={{
												'& .MuiTableCell-root:first-of-type': {
													pl: 2,
												},
												'& .MuiTableCell-root:last-of-type': {
													pr: 3,
												},
											}}
										>
											<TableHead>
												<TableRow style={{ backgroundColor: '#e5e5e5' }}>
													{TABLE_COLUMNS.map((headCell, index) => (
														<TableCell
															key={index}
															align={headCell.align || 'left'}
															padding={headCell.disablePadding ? 'none' : 'normal'}
														>
															{headCell.label === 'Row No' && (
																<img src={excel} alt="excel" width={22} style={{ marginRight: '5px' }} />
															)}{' '}
															{headCell.label}
														</TableCell>
													))}
												</TableRow>
											</TableHead>

											<TableBody>
												{data.excelTable?.map((lrm, index) => (
													<OptimizedTableRow
														key={lrm['Data No.']}
														lrm={lrm}
														index={index}
														columns={TABLE_COLUMNS}
														getCellStyle={getCellStyle}
														getCellContent={getCellContent}
													/>
												))}
											</TableBody>
										</Table>
									</TableContainer>
								</Box>
							)}
						</Form.Item>
					</Col>

					<Col xs={24} sm={24} md={24} xl={24}>
						<Flex justify="flex-end" align="flex-end">
							{uiState.show && (
								<>
									{/* {filesubmitButton && (
										<Button
											style={{ backgroundColor: theme.palette.lynTheme.success, marginRight: '10px' }}
											type="primary"
											onClick={(e) => {
												e.preventDefault();

												setRefetchData((prev) => !prev);
												validateData(excelData);
											}}
										>
											Revalidate
										</Button>
									)} */}
									<Button
										style={{ backgroundColor: theme.palette.error?.main, marginRight: '10px' }}
										type="primary"
										onClick={(e) => {
											e.preventDefault();
											setExcelTable([]);
											setShow(false);
										}}
									>
										Cancel
									</Button>

									<Button
										disabled={uiState?.fileSubmitButton}
										style={{ backgroundColor: uiState?.fileSubmitButton ? '' : theme.palette.lynTheme.submit }}
										type="primary"
										onClick={(e) => {
											e.preventDefault();
											handleExcelSubmit(data.excelTable);
										}}
									>
										Submit
									</Button>
								</>
							)}
						</Flex>
					</Col>
				</Row>
			</Form>

			{uiState?.showModal && (
				<ComptrollerConfirmModal
					showModal={uiState?.showModal}
					setShowModal={setShowModal}
					modalData={data?.modalInfo}
					handleSubmit={handleSubmitExcelData}
				/>
			)}
		</div>
	);
};

export default LeaseBulkUpload;
